@if (slectConfirmation) {
  <div class="confirmation-container">
    <div class="confirmation-header">
      <p class="float-left">{{ data.title }}</p>
      <img class="float-right" src="assets/images/close@2x.png" (click)="closeModal(false)" />
    </div>
    <div class="confirmation-data">
      @if (data.message == '') {
        <p>
          Your request for login is submitted.
        </p>
      } @else {
        <p class="text-left">{{ data.message }}</p>
      }
      <div class="confirm-action">
        <button type="button" class="create-action text-capitalize" (click)="closeModal(true)">
          <span>{{ buttonLableSubmit }}</span>
        </button>
        @if (buttonLableCancel) {
          <button type="button" class="cancel-action" (click)="closeModal(false)">
            <span> {{ buttonLableCancel }}</span>
          </button>
        }
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
}

@if (selectVendor) {
  <div class="confirmation-container">
    <div class="confirmation-header">
      <p class="float-left">Select a Vendor</p>
      <img class="float-right" src="assets/images/close@2x.png" (click)="closeModal(false)" />
    </div>
    <div class="confirmation-data">
      <form class="user-form" [formGroup]="userForm" (submit)="onSubmit()" autocomplete="off">
        <div class="row">
          <div class="form-group col-xs-12 col-sm-12 col-md-12">
            <label for="reporting manager">Vendor Name</label>
            @if (vendorCollections.length > 0) {
              <ng-select class="select-drop-down col-lg-8 col-md-8 p-0" [items]="vendorCollections"
                formControlName="vendor" bindLabel="fullOrganisationName" [clearable]="false" (search)="searchVendor()"
                placeholder="Select Vendor" name="role">
              </ng-select>
            } @else {
              <input class="form-control" type="text" placeholder="No Vendors" disabled />
            }
          </div>
        </div>
        <div class="form-actions confirm-action">
          <button type="submit" class="create-action" name="submitClass"
            [disabled]="userForm.invalid || userForm.pristine">
            <span>Save</span>
          </button>
          <button type="button" class="cancel-action" name="cancelClass" (click)="closeModal(false)">
            <span>Cancel</span>
          </button>
        </div>
      </form>
      <div class="clearfix"></div>
    </div>
  </div>
}